var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.667 3H14M6.667 6.333H14M6.667 9.667H14M6.667 13H14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.835,
    d: "m3.38 2.928 1.017-.604v2.56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.732,
    d: "M3.49 7.418c.638-.736 1.538-.181 1.044.583-.897.985-1.154 1.207-1.154 1.276l1.252.002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.648,
    d: "M3.48 11.72c.558-.48 1.466-.234 1.176.405-.229.372-.747.412-.598.412.694-.098.859.56.467.816-.498.327-.957.013-1.145-.184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListordered);
export default __webpack_public_path__ + "static/media/listordered.73e55967bcd8432d67cfab5ab14d855f.svg";
export { ForwardRef as ReactComponent };